import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import BagIcon from "../assets/img/bag-icon.svg";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  otherDetails,
  saveOtherDetails,
  deleteSaveOtherDetails,
} from "../Actions/otherDetailsAction";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ABYear from "./Common/ABYear";
import ABUpload from "./Common/ABUpload";
import ABText from "./Common/ABText";
import ABCarousel from "./ABCarousel";
import ABSelect from "./Common/ABSelect";
import GetMasterData from "./../Helper/masterData";
import InputField from "./InputField";
import Loader from "./Common/loader";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const CandidateOtherDetailsTwo = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [otherData, setOtherDetailsData] = useState({});
  const [otherData1, setOtherDetailsData1] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [currentEmp, setCurrentEmp] = useState(false);
  const [previousEmp1, setPreviousEmp1] = useState(false);
  const [previousEmp2, setPreviousEmp2] = useState(false);
  const storeData = useSelector((state) => state.otherDetails);
  const [newRecord, setNewRecord] = useState({});
  const storeData2 = useSelector((state) => state.saveOtherDetails);
  const dispatch = useDispatch();
  const [role,setRole]=useState();
  const { otherDetailsData, loading: getLoading, error: getError } = storeData;
  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getLoading]);
  const {
    saveOtherDetailsData,
    loading: saveLoading,
    error: saveError,
  } = storeData2;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveLoading]);
  const [formVal, setFormVal] = useState({});
  const [reference, setReference] = useState();

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    setReference(list.reference_number);
  }, []);

  useEffect(() => {
    if (
      typeof otherDetailsData.data !== "undefined" &&
      otherDetailsData.data !== null
    ) {
      setOtherDetailsData(otherDetailsData?.data?.data?.checksDetails[0]);
      setOtherDetailsData1(otherDetailsData?.data?.data);
    }
    if(otherDetailsData?.data?.group?.group_id == "profile_preview" || otherDetailsData?.group?.group_id == "profile_preview") {
      navigate(`/case-initiation/profile-preview/${reference}`); // to skip other details
    }
  }, [otherDetailsData, storeData]);

  //console.log(otherData);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(otherDetails());
    };
    fetchData();
  }, []);

  useEffect(() => {
    //debugger;
    if (
      typeof saveOtherDetailsData !== "undefined" &&
      saveOtherDetailsData !== null
    ) {
      const group = saveOtherDetailsData.group
        ? saveOtherDetailsData.group.group_id
        : "";
      if (group == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${reference}`);
        dispatch(deleteSaveOtherDetails());
      } else if (typeof group != "undefined" && group != "") {
        navigate(`/case-initiation/check-detail/${reference}/${group}`);
        dispatch(deleteSaveOtherDetails());
      }
    }
  }, [saveOtherDetailsData, storeData2]);

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({});

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const saveOthersDetails = async (e, caseCheckId) => {
    e.preventDefault();
    let hasError = false;
    // debugger;
    if (otherData1.getothersettings[9].educationShow == "") {
      Object.entries(otherData.fields).map(([key, val]) => {
        if (
          (key == "cv_education_college" ||
            key == "cv_education_course" ||
            key == "cv_education_passing_year") &&
          val.is_mandatory == 1 &&
          (val.field_value == "" || val.field_value == null)
        ) {
          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [key]: true,
          }));
        } else if (
          key == "cv_education_college" ||
          key == "cv_education_course" ||
          key == "cv_education_passing_year"
        ) {
          setErrorData((prevState) => ({
            ...prevState,
            [key]: false,
          }));
        }
      });
    }
    if (otherData1.getothersettings[9].currentEmploymentShow == "") {
      Object.entries(otherData.fields).map(([key, val]) => {
        if (
          (key == "cv_current_employment_company" ||
            key == "cv_current_employment_doj" ||
            key == "cv_current_employment_dol") &&
          val.is_mandatory == 1 &&
          (val.field_value == "" || val.field_value == null)
        ) {
          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [key]: true,
          }));
        } else if (
          key == "cv_current_employment_company" ||
          key == "cv_current_employment_doj" ||
          key == "cv_current_employment_dol"
        ) {
          setErrorData((prevState) => ({
            ...prevState,
            [key]: false,
          }));
        }
      });
    }
    if (otherData1.getothersettings[9].previousEmploymentShow == "") {
      Object.entries(otherData.fields).map(([key, val]) => {
        if (
          (key == "cv_previous_employment_company" ||
            key == "cv_previous_employment_company_2" ||
            key == "cv_previous_employment_doj" ||
            key == "cv_previous_employment_doj_2" ||
            key == "cv_previous_employment_dol" ||
            key == "cv_previous_employment_dol_2") &&
          val.is_mandatory == 1 &&
          (val.field_value == "" || val.field_value == null)
        ) {
          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [key]: true,
          }));
        } else if (
          key == "cv_previous_employment_company" ||
          key == "cv_previous_employment_company_2" ||
          key == "cv_previous_employment_doj" ||
          key == "cv_previous_employment_doj_2" ||
          key == "cv_previous_employment_dol" ||
          key == "cv_previous_employment_dol_2"
        ) {
          setErrorData((prevState) => ({
            ...prevState,
            [key]: false,
          }));
        }
      });
    }
    if (hasError == true) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      const recordData = {};
      recordData.case_check_id = caseCheckId;
      const formData = getFormData();
      formData["group"] = "others";
      recordData.check_data = { [caseCheckId]: formData };
      console.log(recordData);
      dispatch(saveOtherDetails(recordData));
    }
  };

  const saveDate = (id, val) => {
    console.log(id);
    let updatedOtherDetails = _.cloneDeep(otherData);
    updatedOtherDetails.fields[id].field_value = val;
    if (val == "Invalid date") {
      updatedOtherDetails.fields[id].field_value = "";
      setOtherDetailsData(updatedOtherDetails);
      setErrorData((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    } else {
      setOtherDetailsData(updatedOtherDetails);
      setErrorData((prevState) => ({
        ...prevState,
        [id]: false,
      }));
    }
  };

  const handleInputChange = (e) => {
    let updatedOtherDetails = _.cloneDeep(otherData);
    updatedOtherDetails.fields[e.target.name].field_value = e.target.value;
    setOtherDetailsData(updatedOtherDetails);
    setErrorData((prevState) => ({
      ...prevState,
      [e.target.name]: false,
    }));
  };

  const getFormData = () => {
    const formData = {};
    Object.entries(otherData.fields).map(([key, val]) => {
      if (val.field_value != null && val.field_value != "") {
        formData[val.ibridge_field_id] = val.field_value;
      }
    });
    return formData;
  };

  const handleCheckbox = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    let updatedOtherDetails = _.cloneDeep(otherData);
    console.log(checked);
    if (checkid == "checkbox1" && checked == true) {
      var eleman = document.getElementById("cv_current_employment_company");
      eleman.setAttribute("disabled", "disabled");
      updatedOtherDetails.fields["cv_current_employment_company"].field_value =
        "";
      updatedOtherDetails.fields[
        "cv_current_employment_company"
      ].is_mandatory = 0;
      updatedOtherDetails.fields["cv_current_employment_doj"].field_value = "";
      updatedOtherDetails.fields["cv_current_employment_doj"].is_mandatory = 0;
      setCurrentEmp(true);
      updatedOtherDetails.fields["cv_current_employment_dol"].field_value = "";
      updatedOtherDetails.fields["cv_current_employment_dol"].is_mandatory = 0;
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_current_employment_company"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_current_employment_doj"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_current_employment_dol"]: false,
      }));
    } else if (checkid == "checkbox1" && checked == false) {
      var eleman = document.getElementById("cv_current_employment_company");
      eleman.removeAttribute("disabled");
      updatedOtherDetails.fields[
        "cv_current_employment_company"
      ].is_mandatory = 1;
      updatedOtherDetails.fields["cv_current_employment_doj"].is_mandatory = 1;
      setCurrentEmp(false);
    }
    if (checkid == "checkbox2" && checked == true) {
      var eleman = document.getElementById("cv_previous_employment_company");
      eleman.setAttribute("disabled", "disabled");
      updatedOtherDetails.fields["cv_previous_employment_company"].field_value =
        "";
      updatedOtherDetails.fields[
        "cv_previous_employment_company"
      ].is_mandatory = 0;
      updatedOtherDetails.fields["cv_previous_employment_doj"].field_value = "";
      updatedOtherDetails.fields["cv_previous_employment_doj"].is_mandatory = 0;
      updatedOtherDetails.fields["cv_previous_employment_dol"].field_value = "";
      updatedOtherDetails.fields["cv_previous_employment_dol"].is_mandatory = 0;
      setPreviousEmp1(true);
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_company"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_doj"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_dol"]: false,
      }));
    } else if (checkid == "checkbox2" && checked == false) {
      var eleman = document.getElementById("cv_previous_employment_company");
      eleman.removeAttribute("disabled");
      updatedOtherDetails.fields[
        "cv_previous_employment_company"
      ].is_mandatory = 1;
      updatedOtherDetails.fields["cv_previous_employment_doj"].is_mandatory = 1;
      updatedOtherDetails.fields["cv_previous_employment_dol"].is_mandatory = 1;
      setPreviousEmp1(false);
    }
    if (checkid == "checkbox3" && checked == true) {
      var eleman = document.getElementById("cv_previous_employment_company_2");
      eleman.setAttribute("disabled", "true");
      updatedOtherDetails.fields[
        "cv_previous_employment_company_2"
      ].field_value = "";
      updatedOtherDetails.fields[
        "cv_previous_employment_company_2"
      ].is_mandatory = 0;
      updatedOtherDetails.fields["cv_previous_employment_doj_2"].field_value =
        "";
      updatedOtherDetails.fields[
        "cv_previous_employment_doj_2"
      ].is_mandatory = 0;
      updatedOtherDetails.fields["cv_previous_employment_dol_2"].field_value =
        "";
      updatedOtherDetails.fields[
        "cv_previous_employment_dol_2"
      ].is_mandatory = 0;
      setPreviousEmp2(true);
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_company_2"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_doj_2"]: false,
      }));
      setErrorData((prevState) => ({
        ...prevState,
        ["cv_previous_employment_dol_2"]: false,
      }));
    } else if (checkid == "checkbox3" && checked == false) {
      var eleman = document.getElementById("cv_previous_employment_company_2");
      eleman.removeAttribute("disabled");
      updatedOtherDetails.fields[
        "cv_previous_employment_company_2"
      ].is_mandatory = 1;
      updatedOtherDetails.fields[
        "cv_previous_employment_doj_2"
      ].is_mandatory = 1;
      updatedOtherDetails.fields[
        "cv_previous_employment_dol_2"
      ].is_mandatory = 1;
      setPreviousEmp2(false);
    }
    setOtherDetailsData(updatedOtherDetails);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {isLoading && <Loader />}
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Others Details"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form ref={form} className="p-3 form2 form-section">
                <StepCount activeTab={"Others Details"} />
                <h2 className="fnt-smi-bld">Others Details</h2>
                {/*<p className="text-muted">To obtain Credit information report from credit bureau kindly sure that enterd mobile.</p>
                 */}{" "}
                <hr />
                {otherData1.getothersettings &&
                  otherData1.getothersettings[9].educationShow == "" && (
                    <>
                      <h6 className="fnt-smi-bld mb-3">Highest Education</h6>
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_education_college.is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={
                                    otherData.fields.cv_education_college
                                      .field_input_type
                                  }
                                  inputName={`cv_education_college`}
                                  inputValue={
                                    otherData.fields.cv_education_college
                                      .field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields.cv_education_college
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields.cv_education_college.label
                                  }
                                  handleOnChange={handleInputChange}
                                />
                                {errorData[`cv_education_college`] == true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {otherData.fields.cv_education_course.is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={
                                    otherData.fields.cv_education_course
                                      .field_input_type
                                  }
                                  inputName={`cv_education_course`}
                                  inputValue={
                                    otherData.fields.cv_education_course
                                      .field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields.cv_education_course
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields.cv_education_course.label
                                  }
                                  handleOnChange={handleInputChange}
                                />
                                {errorData[`cv_education_course`] == true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_education_passing_year
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"year"}
                                  inputName={`cv_education_passing_year`}
                                  inputValue={
                                    otherData.fields.cv_education_passing_year
                                      .field_value
                                  }
                                  index={`cv_education_passing_year`}
                                  isInputMandatory={
                                    otherData.fields.cv_education_passing_year
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields.cv_education_passing_year
                                      .label
                                  }
                                  handleOnChange={handleInputChange}
                                  index={`cv_education_passing_year`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields.cv_education_passing_year
                                      .field_value
                                  }
                                />
                                {errorData[`cv_education_passing_year`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      <hr />
                    </>
                  )}
                {/*<p></p>
                <h6 className="fnt-smi-bld mb-0">Upload File</h6>
                <small className="text-muted">upload degree or certificate </small>
                <p></p>

                <ABUpload
                  name="all_year_marksheet"
                  id="all_year_marksheet"
                  title="All Year Marksheets"
                />

                <div className="form-check mt-3">
                  <input type="checkbox" className="form-check-input" id="submitLater" />
                  <label htmlFor="submitLater" className="form-check-label">I will submit documents later</label>
                </div>*/}
                {otherData1.getothersettings &&
                  otherData1.getothersettings[9].currentEmploymentShow ==
                    "" && (
                    <>
                      <h6 className="fnt-smi-bld mb-3">Current Employment</h6>
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="form-check mt-3 mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkbox1"
                            onChange={(e) => handleCheckbox(e)}
                          />
                          <label
                            htmlFor="notApplicable"
                            className="form-check-label"
                          >
                            Not applicable
                          </label>
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_current_employment_company
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={
                                    otherData.fields
                                      .cv_current_employment_company
                                      .field_input_type
                                  }
                                  inputName={`cv_current_employment_company`}
                                  inputValue={
                                    otherData.fields
                                      .cv_current_employment_company.field_value
                                  }
                                  index={`cv_current_employment_company`}
                                  isInputMandatory={
                                    otherData.fields
                                      .cv_current_employment_company
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields
                                      .cv_current_employment_company.label
                                  }
                                  handleOnChange={handleInputChange}
                                />
                                {errorData[`cv_current_employment_company`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_current_employment_doj
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_current_employment_doj`}
                                  inputValue={
                                    otherData.fields.cv_current_employment_doj
                                      .field_value
                                  }
                                  handleOnChange={handleInputChange}
                                  index={`cv_current_employment_doj`}
                                  isInputMandatory={
                                    otherData.fields.cv_current_employment_doj
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields.cv_current_employment_doj
                                      .label
                                  }
                                  readOnly={currentEmp ? true : false}
                                  index={`cv_current_employment_doj`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields.cv_current_employment_doj
                                      .field_value
                                  }
                                />
                                {errorData[`cv_current_employment_doj`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {otherData.fields.cv_current_employment_dol
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_current_employment_dol`}
                                  inputValue={
                                    otherData.fields.cv_current_employment_dol
                                      .field_value
                                  }
                                  index={`cv_current_employment_dol`}
                                  isInputMandatory={
                                    otherData.fields.cv_current_employment_dol
                                      .is_mandatory
                                  }
                                  handleOnChange={handleInputChange}
                                  inputLabel={
                                    otherData.fields.cv_current_employment_dol
                                      .label
                                  }
                                  readOnly={currentEmp ? true : false}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields.cv_current_employment_dol
                                      .field_value
                                  }
                                />
                                {errorData[`cv_current_employment_dol`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      <hr />
                    </>
                  )}
                {otherData1.getothersettings &&
                  otherData1.getothersettings[9].previousEmploymentShow ==
                    "" && (
                    <>
                      <h6 className="fnt-smi-bld mb-3">
                        Previous Employment Details 1
                      </h6>
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="form-check mt-3 mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkbox2"
                            onChange={(e) => handleCheckbox(e)}
                          />
                          <label
                            htmlFor="notApplicable2"
                            className="form-check-label"
                          >
                            Not applicable
                          </label>
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_previous_employment_company
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={
                                    otherData.fields
                                      .cv_previous_employment_company
                                      .field_input_type
                                  }
                                  inputName={`cv_previous_employment_company`}
                                  inputValue={
                                    otherData.fields
                                      .cv_previous_employment_company
                                      .field_value
                                  }
                                  index={`cv_previous_employment_company`}
                                  isInputMandatory={
                                    otherData.fields
                                      .cv_previous_employment_company
                                      .is_mandatory
                                  }
                                  inputLabel={
                                    otherData.fields
                                      .cv_previous_employment_company.label
                                  }
                                  handleOnChange={handleInputChange}
                                />
                                {errorData[`cv_previous_employment_company`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_previous_employment_doj
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_previous_employment_doj`}
                                  inputValue={
                                    otherData.fields.cv_previous_employment_doj
                                      .field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields.cv_previous_employment_doj
                                      .is_mandatory
                                  }
                                  index={`cv_previous_employment_doj`}
                                  inputLabel={
                                    otherData.fields.cv_previous_employment_doj
                                      .label
                                  }
                                  readOnly={previousEmp1 ? true : false}
                                  index={`cv_previous_employment_doj`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields.cv_previous_employment_doj
                                      .field_value
                                  }
                                />
                                {errorData[`cv_previous_employment_doj`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {otherData.fields.cv_previous_employment_dol
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_previous_employment_dol`}
                                  inputValue={
                                    otherData.fields.cv_previous_employment_dol
                                      .field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields.cv_previous_employment_dol
                                      .is_mandatory
                                  }
                                  readOnly={previousEmp1 ? true : false}
                                  inputLabel={
                                    otherData.fields.cv_previous_employment_dol
                                      .label
                                  }
                                  index={`cv_previous_employment_dol`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields.cv_previous_employment_dol
                                      .field_value
                                  }
                                />
                                {errorData[`cv_previous_employment_dol`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      <hr />
                    </>
                  )}
                {otherData1.getothersettings &&
                  otherData1.getothersettings[9].previousEmploymentShow ==
                    "" && (
                    <>
                      <h6 className="fnt-smi-bld mb-3">
                        Previous Employment Details 2
                      </h6>
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="form-check mt-3 mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkbox3"
                            onChange={(e) => handleCheckbox(e)}
                          />
                          <label
                            htmlFor="notApplicable2"
                            className="form-check-label"
                          >
                            Not applicable
                          </label>
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_previous_employment_company_2
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={
                                    otherData.fields
                                      .cv_previous_employment_company_2
                                      .field_input_type
                                  }
                                  inputName={`cv_previous_employment_company_2`}
                                  inputValue={
                                    otherData.fields
                                      .cv_previous_employment_company_2
                                      .field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields
                                      .cv_previous_employment_company_2
                                      .is_mandatory
                                  }
                                  index={`cv_previous_employment_company_2`}
                                  inputLabel={
                                    otherData.fields
                                      .cv_previous_employment_company_2.label
                                  }
                                  handleOnChange={handleInputChange}
                                />
                                {errorData[
                                  `cv_previous_employment_company_2`
                                ] == true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {otherData && otherData.is_form_required == 1 && (
                        <div className="row">
                          {otherData.fields.cv_previous_employment_doj_2
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_previous_employment_doj_2`}
                                  inputValue={
                                    otherData.fields
                                      .cv_previous_employment_doj_2.field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields
                                      .cv_previous_employment_doj_2.is_mandatory
                                  }
                                  index={`cv_previous_employment_doj_2`}
                                  inputLabel={
                                    otherData.fields
                                      .cv_previous_employment_doj_2.label
                                  }
                                  readOnly={previousEmp2 ? true : false}
                                  index={`cv_previous_employment_doj_2`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields
                                      .cv_previous_employment_doj_2.field_value
                                  }
                                />
                                {errorData[`cv_previous_employment_doj_2`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {otherData.fields.cv_previous_employment_dol_2
                            .is_visible ? (
                            <div className="col-sm-4 col-md-12 col-xl-4">
                              <div className="form-group">
                                <InputField
                                  inputType={"date"}
                                  inputName={`cv_previous_employment_dol_2`}
                                  inputValue={
                                    otherData.fields
                                      .cv_previous_employment_dol_2.field_value
                                  }
                                  isInputMandatory={
                                    otherData.fields
                                      .cv_previous_employment_dol_2.is_mandatory
                                  }
                                  readOnly={previousEmp2 ? true : false}
                                  index={`cv_previous_employment_dol_2`}
                                  inputLabel={
                                    otherData.fields
                                      .cv_previous_employment_dol_2.label
                                  }
                                  index={`cv_previous_employment_dol_2`}
                                  saveDate={saveDate}
                                  showDate={
                                    otherData.fields
                                      .cv_previous_employment_dol_2.field_value
                                  }
                                />
                                {errorData[`cv_previous_employment_dol_2`] ==
                                true ? (
                                  <p className="text-danger">
                                    This field is required.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </>
                  )}
                {otherData && otherData.is_form_required == 1 && (
                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) =>
                          saveOthersDetails(e, otherData.case_check_id)
                        }
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
                {Object.keys(otherData).length > 0 &&
                  otherData.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                         {clientId == 459831 ? "Preview" : "Submit for Preview"} 
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    {/*<button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>*/}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidateOtherDetailsTwo;
